import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import moment from 'moment'
import PropTypes from 'prop-types'
import twix from 'twix'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import classnames from 'classnames'

const propTypes = {
    active: PropTypes.number,
}

const defaultProps = {
    active: 0,
}

const News = ({ active }) => (
    <StaticQuery
        query={graphql`
            query NewsQuery {
                    allDatoCmsNews(sort: {order: DESC, fields: publishDate}) {
                        nodes {
                            id
                            title
                            slug
                            description
                            publishDate
                            body
                        }
                    }
                }

        `}
        render={data => (
            <div>
                {data.allDatoCmsNews.nodes.map(el => {
                    const h3Classes = classnames({
                        'font-header  font-bold text-2xl  font-normal  mb-4': true,
                        'text-sky': active !== parseInt(el.id),
                        'text-mauve': active === parseInt(el.id),
                    })

                    return (
                        <article
                            key={el.slug}
                            className="mb-5  text-justify  js-news-list-item  cursor-pointer"
                        >
                            <span className="text-black">
                                {moment(el.publishDate).format('MMMM Do, YYYY')}
                            </span>

                            <AniLink
                                fade
                                key={el.id}
                                to={`/news/${el.slug}`}
                                className="no-underline  hover:underline hover:text-cobalt"
                            >
                                <h3 className={h3Classes}>{el.title}</h3>
                            </AniLink>
                        </article>
                    )
                })}
            </div>
        )}
    />
)

News.propTypes = propTypes
News.defaultProps = defaultProps

export default News
